/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './WithholdingDisclosureModal.scss';

import { func } from 'prop-types';
import React from 'react';

import Disclosure from 'components/shared/Disclosure/Disclosure';
import BaseModal from 'components/shared/Modal/BaseModal';
import {
  disclosureCopyAccountType,
  disclosureTitle
} from 'services/DividendsCapitalGains';

const WithholdingDisclosureModal = ({ onClose, accountTypeId }) => (
  <BaseModal
    close={onClose}
    containerClassName="withholding-disclosure-modal"
    hideAnchor={true}
    isOpen={true}
    title={disclosureTitle(accountTypeId)}>
    <Disclosure content={disclosureCopyAccountType(accountTypeId)} />
  </BaseModal>
);

WithholdingDisclosureModal.propTypes = {
  onClose: func.isRequired
};

export default WithholdingDisclosureModal;
